import Franchise from './pages/Franchise';
import Stores from './pages/Stores';
import Landing from './pages/Landing';
//import How from './pages/How';
import Concept from './pages/Concept';
import Media from './pages/Media';
import Gdpr from './pages/GDPR';
import Franchisee from './pages/Franchisee';

export const APP_ROUTES = {
    landing: '/',
    how: '/hur',
    concept: '/koncept',
    franchise: '/franchise',
    stores: '/butiker',
    media: '/media',
    gdpr: '/gdpr',
    franchisee: '/franchisetagare',
};

export const NAVIGATION_ROUTES: Object[] = [
    //{ text: 'nav.how', route: APP_ROUTES.how, component: How },
    { text: 'nav.concept', route: APP_ROUTES.concept, component: Concept },
    { text: 'nav.franchise', route: APP_ROUTES.franchise, component: Franchise },
    { text: 'nav.stores', route: APP_ROUTES.stores, component: Stores },
];

export const SWITCH_ROUTES = [
    ...NAVIGATION_ROUTES,
    { text: 'nav.landing', route: APP_ROUTES.landing, component: Landing },
    { text: 'nav.media', route: APP_ROUTES.media, component: Media },
    { text: 'nav.gdpr', route: APP_ROUTES.gdpr, component: Gdpr },
    { text: 'nav.franchisee', route: APP_ROUTES.franchisee, component: Franchisee },
];
